<template>
  <div class="business-card" v-cloak>
    <div class="l-top">
      <!-- 顶部打开app -->
      <openAppDialog
        ref="openApp"
        :isShow="isShareWeb"
        :title="openTitle"
        :shareId="shareId"
        @openApp="openApp"
        @hideMongolia="hideMongolia()"
      ></openAppDialog>
      <div class="header">
        <van-loading size="24px" v-if="loading">加载中...</van-loading>
        <div v-if="!loading">
          <!-- 视频 -->
          <van-image
            v-if="isAndroid && !showVideo"
            fit="cover"
            :src="playerOptions.poster"
            class="bg-image"
          ></van-image>
          <div v-else class="video">
            <video-player
              class="video-player vjs-custom-skin"
              ref="videoPlayer"
              :playsinline="true"
              :options="playerOptions"
              @play="onPlayerPlay($event)"
              @pause="onPlayerPause($event)"
            ></video-player>
            <van-image
              :src="waterMarkImage"
              class="water-marker"
              v-if="isWaterMarkImage"
            ></van-image>
          </div>
          <div class="header-location">
            <p>{{ title }}</p>
            <p class="number">{{ playCount }}次播放</p>
          </div>
        </div>
      </div>
      <div class="grap"></div>
    </div>
    <!-- 视频列表 -->
    <div class="l-list">
      <van-list
        v-model="loadingList"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        v-if="noList"
      >
        <div class="list">
          <div
            class="list-item"
            v-for="(item, index) in classData"
            :key="index"
            @click="playVideo(item)"
          >
            <div class="l-left">
              <van-image :src="item.coverUrl" class="image"></van-image>
              <div class="mark" v-if="item.playing">
                <lottie
                  class="lottie"
                  :options="defaultOptions"
                  :height="14"
                  :width="16"
                  v-on:animCreated="handleAnimation"
                />
              </div>
            </div>
            <div class="content">
              <p class="title">{{ item.title }}</p>
              <p>{{ item.playCount }}次播放</p>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <empty
      ref="emptyView"
      :toastTitle="toastTitle"
      :emptyShow="emptyShow"
    ></empty>
  </div>
</template>
<script>
/* eslint-disable */
import BScroll from "better-scroll";
import { videoPlayer } from "vue-video-player";
import empty from "@/components/empty.vue";
import openAppDialog from "@/components/openAppTopDialog.vue";
import Lottie from "@/components/lottie.vue";
import * as animationData from "../../assets/data.json";
export default {
  data() {
    return {
      data: "",
      loading: true,
      loadingList: false,
      videoId: "",
      autoplayTime: 3000,
      cover_img: "",
      title: "", // 标题
      playCount: "", // 浏览次数
      // ---------------------- 视频
      isAndroid: "",
      showVideo: true,
      playerOptions: {
        //        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4",
            src: "", // 你的视频地址（必填）
          },
        ],
        poster: "", // 你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: "正在加载视频", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, // 全屏按钮
        },
      },
      waterMarkImage: require("../../assets/iconImage/ic_watermark@3x.png"),
      isWaterMarkImage: true,
      notAudio: true,
      toastTitle: "糟糕,数据找不到了",
      emptyShow: false,
      isShareWeb: true,
      shareId: this.$route.query.id,
      openTitle: "打开天府绿道APP<br/>欣赏更多精彩视频",
      lat: "30.56979",
      lng: "104.05453",

      // 分类列表有无数据展示
      firstData: {},
      classData: [],
      noList: true,
      finished: false,
      pageIndex: 0,
      pageSize: "10",

      defaultOptions: { animationData: animationData.default },
      currentVideoId: "",
    };
  },
  components: {
    videoPlayer,
    empty,
    openAppDialog,
    lottie: Lottie,
  },
  created() {
    // eslint-disable-next-line
    var u = navigator.userAgent,
      // eslint-disable-next-line
      app = navigator.appVersion;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
    //var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
      this.notAudio = false;
    }
    var ua = window.navigator.userAgent.toLowerCase(),
      isWx = ua.match(/MicroMessenger/i) == "micromessenger",
      isQQ = ua.match(/QQ/i) == "qq",
      isWeiBo = ua.match(/WeiBo/i) == "weibo";
    this.getData();
    if (isWx || isQQ || isWeiBo) {
      this.getData();
    } else {
      this.commonLatLong((LatLng) => {
        this.lat = LatLng.latitude;
        this.lng = LatLng.longitude;
        this.getData();
      });
    }
  },
  methods: {
    // 获取短视频详情
    
    getData(id) {
      const that = this;
      var id;
      if(id){
        id=id
      }else{
        id = that.$route.query.id;
      }
      
      that.$http
        .get(`/appserver/v1/short/video?id=${id}`)
        .then((data) => {
          that.data = data.data.data;
          // if (that.data.online_status !== 1) {
          //   that.loading = false;
          //   that.toastTitle = "糟糕,数据找不到了";
          //   that.emptyShow = true;
          //   return;
          // }
          that.videoId = that.data.id;
          document.title = that.data.title;
          that.title = that.data.title; // 名称
          that.playCount = that.data.playCount; // 播放次数
          // /short/video 接口返回的数据，需要覆盖视频列表的第一条数据
          that.firstData = that.data;
          that.loading = false;
        })
        .catch((error) => {
          that.toastTitle = "网络异常,检查网络再试试~~";
          that.emptyShow = true;
        });
    },
    // 上拉加载视频列表
    onLoad() {
      this.pageIndex = this.pageIndex + 1;
      this.shortVideoList();
    },
    // 获取短视频推荐列表
    shortVideoList() {
      let topicId = 1;
      const that = this;
      let id = that.$route.query.id;
      that.$http
        .get(
          `/appserver/v1/short/video/recommends?id=${id}&pageIndex=${that.pageIndex}&pageSize=${that.pageSize}`
        )
        .then((data) => {
          if (data.data.ret === 0) {
            const res = data.data.data;
            console.log(that.firstData, "that.firstData");
            if (res && res.length === 0) {
              that.finished = true;
            }
            that.classData.push(...res);
            that.classData[0] = that.firstData;
            console.log(that.classData, "that.classData****************");
            that.loadingList = false;
            that.classData.forEach((items) => {
              items.playing = false;
            });
            this.playerOptions.sources[0].src = that.classData[0].playUrl; // 视频
            this.playerOptions.poster = that.classData[0].coverUrl;
            this.currentVideoId = that.classData[0].id;
            if (that.classData.length === 0) {
              that.noList = false;
            } else {
              that.noList = true;
            }
          } else {
            console.log(data.data);
            that.loadingList = false;
          }
        })
        .catch((error) => {
          console.log("error");
          that.loadingList = false;
        });
    },
    // 视频播放
    // eslint-disable-next-line
    onPlayerPlay(player) {
      console.log(player, this.currentVideoId, "player-------");
      this.autoplayTime = 0;
      let idx = this.classData.findIndex(
        (item) => item.id === this.currentVideoId
      );
      if (idx != -1) {
        this.classData[idx].playing = true;
      }
      // this.isWaterMarkImage = true;
    },
    // eslint-disable-next-line
    onPlayerPause(player) {
      this.autoplayTime = 3000;
      // this.isWaterMarkImage = false;
    },
    // 播放列表页视频
    playVideo(item) {
      this.getData(item.id)
      console.log(item, "item********");
      this.classData.forEach((items) => {
        items.playing = false;
      });
      this.title = item.title; // 名称
      document.title = item.title;
      this.playCount = item.playCount; // 播放次数
      this.currentVideoId = item.id;
      this.playerOptions.sources[0].src = item.playUrl; // 视频
      this.playerOptions.poster = item.coverUrl;
      this.classData = JSON.parse(JSON.stringify(this.classData));
    },

    handleAnimation(anim) {
      this.anim = anim;
    },
    openApp(isAndroid) {
      console.log("isAndroid****", isAndroid);
      this.isAndroid = isAndroid;
      this.showVideo = false;
    },
    hideMongolia() {
      this.showVideo = true;
    },
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
};
</script>
<style lang="scss" scoped>
[v-cloak] {
  display: none;
}

.business-card {
  overflow: hidden;
  /deep/ .van-loading {
    margin-top: 20px;
    text-align: center;
  }
  .l-top {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    background: #fff;
    .header {
      width: 100%;
      .bg-image {
        width: 100%;
        height: 210px;
        display: block;
      }
      // 视频
      .video {
        height: 210px;
        overflow: hidden;
        width: 100%;
        box-sizing: border-box;
        position: relative;
        /deep/ .vjs-custom-skin > .video-js {
          height: 210px;
        }
        /deep/ .vjs_video_3-dimensions.vjs-fluid {
          padding-top: 0px;
        }
        /deep/ .vjs-fluid {
          padding-top: 0px !important;
        }
        /deep/ .vjs-custom-skin > .video-js .vjs-big-play-button {
          position: absolute;
          width: 50px;
          height: 50px !important;
          line-height: 50px !important;
          margin: 0 !important;
          border-radius: 50%;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          border: 0px;
        }
        /deep/ .vjs-poster {
          width: 100%;
          background-size: 100%;
        }
        .water-marker {
          position: absolute;
          right: 3px;
          top: 3px;
          width: 100px;
          height: 22px;
        }
      }
      .header-location {
        padding: 24px 20px;
        & > p {
          font-size: 26px;
          font-family: PingFangSC;
          font-weight: 600;
          color: rgba(55, 56, 77, 1);
          line-height: 28px;
          &:nth-of-type(2) {
            margin-top: 13px;
            color: rgba(153, 153, 153, 1);
            font-size: 12px;
            line-height: 14px;
          }
        }
      }
    }
    .grap {
      width: 100%;
      height: 5px;
      background: rgba(248, 248, 248, 1);
    }
  }
  .l-list {
    margin-top: 373px;
    .list {
      padding: 20px 20px 0;
      box-sizing: border-box;
      .list-item {
        display: flex;
        align-items: center;
        margin-bottom: 21px;
        border-radius: 2px;
        .l-left {
          position: relative;
          .image {
            display: block;
            width: 160px;
            height: 100px;
            border-radius: 2px;
            /deep/ .van-image__img {
              border-radius: 2px;
            }
          }
          .mark {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.3);
            border-radius: 2px;
            .lottie {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
        .content {
          flex: 1;
          width: 160px;
          margin-left: 15px;
          font-size: 12px;
          line-height: 14px;
          color: rgba(153, 153, 153, 1);
          .title {
            font-weight: 600;
            font-size: 15px;
            color: rgba(85, 89, 89, 1);
            line-height: 17px;
            margin-bottom: 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
  .share-box {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 1500;
    .bg-color {
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 1600;
      background: rgba(0, 0, 0, 0.3);
      .share {
        width: 100%;
        height: 22%;
        padding: 20px;
        box-sizing: border-box;
        background: #fff;
        position: absolute;
        bottom: 0px;
        left: 0px;
        padding-bottom: 20px;
        z-index: 1700;
        & > div {
          display: flex;
          &:nth-of-type(1) {
            justify-content: space-between;
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFangSC;
            font-weight: 500;
            color: rgba(74, 74, 74, 1);
            & > p:nth-of-type(2) {
              color: rgba(46, 186, 115, 1);
            }
          }
          &:nth-of-type(2) {
            justify-content: space-around;
            margin-top: 30px;
          }
        }
      }
    }
  }
}
</style>
